import React, { useContext, useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";

import api from "../../services/api";
import { i18n } from "../../translate/i18n.js";
import toastError from "../../errors/toastError";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import {
  SettingsCard,
  SectionHeader,
  SectionDivider,
  ToggleRow,
} from "../../pages/Settings/components/SettingsPattern";

// feat_416 (CK23) — Ajustes › Automatizaciones › "Mensaje de bienvenida una sola vez".
//   - welcomeNoticeOnce       (switch, apagado por defecto)
//   - welcomeNoticeMatch      (fragmentos "a|b", guardan en onBlur)
//   - aiReplyBlockIfAssigned  (switch, apagado por defecto)
// Los TabPanels de /Settings quedan montados: este bloque no se desmonta.

const WelcomeNoticeSettings = () => {
  const { getSetting } = useContext(SettingsContext);
  const enabledCtx = getSetting("welcomeNoticeOnce") === "true";
  const matchCtx = getSetting("welcomeNoticeMatch") || "";
  const blockCtx = getSetting("aiReplyBlockIfAssigned") === "true";
  const [enabled, setEnabled] = useState(enabledCtx);
  const [match, setMatch] = useState(matchCtx);
  const [block, setBlock] = useState(blockCtx);

  useEffect(() => setEnabled(enabledCtx), [enabledCtx]);
  useEffect(() => setMatch(matchCtx), [matchCtx]);
  useEffect(() => setBlock(blockCtx), [blockCtx]);

  const save = async (key, value) => {
    try {
      await api.put(`/settings/${key}`, { value });
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <SettingsCard id="welcome-notice-section">
      <SectionHeader
        title={i18n.t("welcomeNotice.sectionTitle")}
        description={i18n.t("welcomeNotice.sectionHelp")}
      />
      <ToggleRow
        id="setting-welcomeNoticeOnce"
        label={i18n.t("welcomeNotice.enabledLabel")}
        help={i18n.t("welcomeNotice.enabledHelp")}
        tooltip={i18n.t("welcomeNotice.enabledTooltip")}
        checked={enabled}
        onChange={async e => {
          const val = e.target.checked ? "true" : "false";
          setEnabled(e.target.checked);
          await save("welcomeNoticeOnce", val);
        }}
      />
      <TextField
        label={i18n.t("welcomeNotice.matchLabel")}
        value={match}
        onChange={e => setMatch(e.target.value)}
        onBlur={() => save("welcomeNoticeMatch", match)}
        placeholder={i18n.t("welcomeNotice.matchPlaceholder")}
        helperText={i18n.t("welcomeNotice.matchHelp")}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        size="small"
        fullWidth
        multiline
        rows={2}
        margin="dense"
        inputProps={{ maxLength: 1000 }}
      />
      <SectionDivider />
      <ToggleRow
        id="setting-aiReplyBlockIfAssigned"
        label={i18n.t("welcomeNotice.blockLabel")}
        help={i18n.t("welcomeNotice.blockHelp")}
        tooltip={i18n.t("welcomeNotice.blockTooltip")}
        checked={block}
        onChange={async e => {
          const val = e.target.checked ? "true" : "false";
          setBlock(e.target.checked);
          await save("aiReplyBlockIfAssigned", val);
        }}
      />
    </SettingsCard>
  );
};

export default WelcomeNoticeSettings;
